enum TypeDialogMessageEnum {
    Success = 1,
    Warning,
    Error,
    Info,
    Question,
}

const TypeCardEnumLabel = new Map<TypeDialogMessageEnum, string>([
    [TypeDialogMessageEnum.Success, "Success"],
    [TypeDialogMessageEnum.Warning, "Warning"],
    [TypeDialogMessageEnum.Error, "Error"],
    [TypeDialogMessageEnum.Info, "Info"],
    [TypeDialogMessageEnum.Question, "Question"],
]);

export { TypeDialogMessageEnum, TypeCardEnumLabel };
